module.exports = __webpack_public_path__ + "static/media/06.31ba82ad.png";